import React from 'react';
import styles from './AddInvoice.module.scss';

const AddInvoice: React.FC = () => {
  return (
    <div className={styles.addInvoice}>
      <h1>Add Invoice</h1>
      <p>Invoice creation form will be implemented here.</p>
    </div>
  );
};

export default AddInvoice; 